import React, { FC, useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import {
    Dialog,
    IconButton,
    Button,
    Stack,
    ButtonGroup, 
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Switch,
    Link,
    Checkbox,
} from '@material-ui/core'
import { initializeApp, getApps } from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'
import useStore from 'store'
import { useTranslation } from 'react-i18next'
import { theme, Text, Row, Space, Icon } from 'ui'
import { observer } from 'mobx-react'


const StyledCookieContainer = styled.div`
  z-index: 1200; 
  position: fixed; 
  bottom: 0; 
  left: 0; 
  text-align: center;  
  width: 100%;
  padding: 8px 5px;
  color: white;
  background-color:rgba(0, 0, 0, 0.5);
`

const StyledLink = styled(Link)`
  color: #1ed14b;
  padding-right: 3px;
`

const StyledButton = styled(Button)`
  margin-right: 60px;
  border-radius: 15px;
  background: white;
  border: 4x;
  padding: 2px 5px;
  &:hover {
    background: #f6f7f7;
  }
`


const CookieBunner: FC = () => {
    const { t } = useTranslation('budget')
    const { modulesStore } = useStore()
    
    return (!modulesStore.cookiePolicyPresentState) ? (
      <StyledCookieContainer>
        אנו משתמשים בעוגיות חיוניות לצורך הזדהות ושמירה על אבטחת המשתמשים. המשך השימוש באתר מהווה הסכמה לשימוש זה. 
        <StyledLink style={{ cursor: "pointer" }} onClick={() => {
          modulesStore.openCookiePolicyModal();
        }}>
          למד עוד
        </StyledLink>
        <StyledButton color="primary" variant="outlined" onClick={() => {
          localStorage.setItem('@cookie_consent', JSON.stringify({ necessary: true, statistics: true }));
          try {
            const firebaseConfig = {
              apiKey: "AIzaSyAQT_cb0iRVbPK-lmHLJaZgqwaFaJJGxAc",
              authDomain: "soy-zone-750.firebaseapp.com",
              databaseURL: "https://soy-zone-750.firebaseio.com",
              projectId: "soy-zone-750",
              storageBucket: "soy-zone-750.appspot.com",
              messagingSenderId: "464930886928",
              appId: "1:464930886928:web:a348cb93f215f2f4f7c195",
              measurementId: "G-3X7VNQ762T"
            };
            
            // Check if app is already initialized
            const apps = getApps();
            let app;
            if (apps.length === 0) {
              app = initializeApp(firebaseConfig, 'analytics');
            } else {
              // Find existing app or create new one with name
              app = apps.find(a => a.name === 'analytics') || initializeApp(firebaseConfig, 'analytics');
            }
                                 
            getAnalytics(app);
          } catch (e) {
            console.log("firebase.initializeApp error", e)
          } finally {
            modulesStore.cookiePolicyPresentState = true
          }
        }}>הבנתי</StyledButton>
      </StyledCookieContainer> 
    ) : (<></>)
}

export default observer(CookieBunner)


